module.exports = __webpack_public_path__ + "static/talos-DND3_FnP-412962e3ecdf7fd814dead01581ea3d0.webp";